<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 トップページ トップ一覧
            p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページトップ一覧画面
            h3.box-title トップ一覧
            TopList(apiname='top',editPath='edit')
            router-link(to='edit')
              el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import TopList from '@/views/components/swan/common/List'
export default {
  name: 'Top',
  data () {
    return {
    }
  },
  components: {
    TopList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/top/list.vue